<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="iconOnly ? '0 0 100 100' : '-2 0 340 101'"
    fill="none"
  >
    <g transform="translate(13, -8)">
      <path
        v-if="!iconOnly"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M161.745 47.5089C157.323 47.5089 154.205 49.1249 152.504
          51.5629V34.2429H144.113V79.2849H152.504V62.6739C152.504 58.1109
          154.97 55.1629 159.421 55.1059C163.616 54.9919 166.082
          57.6289 166.082 62.9009V79.2849H174.473V61.6539C174.473
          50.5419 167.584 47.5089 161.745 47.5089Z
          M178.441 79.2849H186.832V48.1039H178.441V79.2849Z
          M178.328 43.2849H186.832V35.2059H178.328V43.2849Z
          M207.723 72.4539C203.159 72.4539 199.729 69.2219
          199.729 63.8079C199.729 58.3659 203.159 54.9919
          207.723 54.9919C212.343 55.0489 215.688 58.3659
          215.688 63.7519C215.688 69.2219 212.343 72.4539 207.723 72.4539Z
          M209.565 47.5089C204.775 47.5089 201.062 49.6629
          199.502 52.3559L199.021 48.1039H191.169V91.2759H199.559V75.3169C201.175 78.0949
          205.002 79.9369 209.565 79.9369C218.58 79.9369 224.334 73.6439 224.334 63.7519C224.334
          53.3199 218.098 47.5089 209.565 47.5089Z
          M247.181 71.9149H236.976V61.0019H247.351C251.235 61.0019 253.701 63.0429
          253.701 66.5579C253.701 70.0439 251.32 71.9149 247.181 71.9149Z
          M252.51 48.7559C252.51 51.8179 250.469 54.2269 246.388 54.2269H236.976V43.4839H246.076C250.526
          43.4839 252.51 45.7519 252.51 48.7559Z M255.742 56.9199C259.994 55.1629 261.269 51.1659
          261.269 47.7359C261.269 40.5359 256.224 36.0849 246.699 36.0849H228.388V79.2849H247.947C257.017
          79.2849 262.715 74.7779 262.715 67.1809C262.715 62.5609 260.306 58.4789 255.742 56.9199Z
          M273.033 63.6379C273.033 58.0539 276.095 54.5669 280.772 54.5669C285.449 54.5669 288.51
          58.0539 288.51 63.6379C288.51 69.1369 285.449 72.7369 280.772 72.7369C276.095 72.7369
          273.033 69.1369 273.033 63.6379Z
          M264.444 63.6949C264.444 73.4179 271.219 79.8809 280.772 79.8809C290.296 79.8809 297.071
          73.4179 297.071 63.6949C297.071 54.0289 290.296 47.4239 280.772 47.4239C271.219 47.4239
          264.444 54.0289 264.444 63.6949Z M316.885 72.3969C312.321 72.3969 308.891 69.1369 308.891
          63.6949C308.891 58.2809 312.321 54.9639 316.885 54.9919C321.506 55.0209 324.851 58.2809 324.851
          63.6949C324.851 69.0809 321.506 72.3969 316.885 72.3969Z M318.728 47.5089C314.107 47.5089 310.394
          49.3519 308.778 52.1009V34.2429H300.331V79.2849H308.183L308.665 75.0899C310.224 77.7829 313.994 79.8809
          318.728 79.8809C327.317 79.8809 333.496 74.0699 333.496 63.6949C333.496 53.7449 327.685 47.5089 318.728
          47.5089Z M141.222 66.8129C141.222 60.0379 137.509 55.7859 129.543 54.2269L122.712 52.9519C118.091
          52.0439 116.334 50.4849 116.334 47.6789C116.334 44.5609 119.225 42.5199 123.789 42.5199C128.523 42.5199
          132.066 44.3059 132.066 48.6429H140.514C140.514 39.0899 132.35 35.4899 123.902 35.4899C113.584 35.4899
          107.518 41.1309 107.518 48.4439C107.518 54.9359 111.799 59.0739 119.509 60.5199L126.312 61.8239C130.507
          62.6179 132.293 64.0629 132.293 67.0399C132.293 70.4699 129.062 72.6239 124.271 72.6239C118.205 72.6239
          115.257 70.1009 115.257 66.5579H106.554C106.554 74.5519 113.273 79.8239 124.271 79.8239C133.795 79.8239
          141.222 75.1469 141.222 66.8129Z"
        :fill="textColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.772 53.887V73.73L37.673 89.575L64.602 73.73V47.651L41.641
          61.144C39.118 62.618 36.227 62.618 33.704 61.144L2.466 42.747C-0.822 40.791
          -0.822 35.887 2.466 33.959L33.704 15.534C36.227 14.06 39.118 14.06 41.641 15.534L64.602
          29.084L54.029 35.292L37.673 25.682L30.019 30.218L16.186 38.41L23.471 42.69L37.673 51.137L66.7
          34.073C68.344 33.109 70.583 33.251 72.227 34.101C74.013 35.037 75.345 36.851 75.345
          39.147V75.459C75.345 78.293 73.928 80.759 71.49 82.205L41.641 99.78C39.147 101.282
          36.227 101.282 33.704 99.78L3.855 82.205C1.418 80.759 0.029 78.322 0.029 75.459V69.704V47.566L10.772
          53.887Z"
        fill="#175DFF"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
interface Props {
  width?: string | number;
  height?: string | number;
  iconOnly?: boolean;
  textColor?: string;
}

withDefaults(defineProps<Props>(), {
  width: "155",
  height: "40",
  iconOnly: false,
  textColor: "#0B073B",
});
</script>
